var map = {
	"./admin-dashboard/admin-dashboard.module": [
		"./src/app/admin-dashboard/admin-dashboard.module.ts",
		"admin-dashboard.module"
	],
	"./client-dashboard/client-dashboard.module": [
		"./src/app/client-dashboard/client-dashboard.module.ts",
		"client-dashboard.module"
	],
	"./user-dashboard/user-dashboard.module": [
		"./src/app/user-dashboard/user-dashboard.module.ts",
		"user-dashboard.module"
	],
	"./vendor-portal/vendor-portal.module": [
		"./src/app/vendor-portal/vendor-portal.module.ts",
		"vendor-portal.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main